export default __webpack_public_path__ + "static/media/i_bus-gen_rd.caea041d.svg";